import styled from "styled-components";

export const SolicitacaoMsgWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  margin-bottom: 24px;
  max-height: 88px;

  box-sizing: border-box;

  border: 1px solid ${(props) => props?.tema?.primaryColor};

  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05),
    0px 4px 8px rgba(48, 49, 51, 0.1);
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 16px;
    flex-direction: column;
    max-height: none;
    gap: 10px;
  }
`;

export const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  svg {
    margin-top: 6px;

    * {
      fill: ${(props) => props?.tema?.primaryColor};
    }
  }

  h2 {
    font-size: 16px;
    line-height: normal;
    color: ${(props) => props?.tema?.primaryColor};
    margin: 0;
  }

  span {
    color: #4d4d4d;
    font-size: 16px;
    line-height: 24px;
  }

  @media (max-width: 768px) {
    gap: 14px;

    h2 {
      font-size: 16px;
      text-align: ${(props) =>
        props?.solicitacaoRespondida ? "left" : "center"};
    }

    span {
      font-size: 13px;
      line-height: 20px;
    }

    svg {
      width: 32px;
    }
  }
`;
